import { QueryClient } from "@tanstack/react-query";

// The app's one query client. Its own module so non-React code (axios
// interceptors) can invalidate queries too.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
